export default (params) => ({
  trigger: {
    name: 'split_test.list_split_tests',
    params: params,
  },
  config: {
    schema: {
      split_tests_0: {
        type: 'string',
      },
      split_tests_1: {
        type: 'string',
      },
      split_tests_2: {
        type: 'string',
      },
      split_tests_3: {
        type: 'string',
      },
      split_tests_4: {
        type: 'string',
      },
      split_tests_5: {
        type: 'string',
      },
      split_tests_6: {
        type: 'string',
      },
      split_tests_7: {
        type: 'string',
      },
      split_tests_8: {
        type: 'string',
      },
      split_tests_9: {
        type: 'string',
      },
      split_tests_10: {
        type: 'string',
      },
      split_tests_11: {
        type: 'string',
      },
    },
    event: {
      name: 'split_tests',
      params: {
        sub_feature: null,
      },
    },
    nonInt: true,
  },
});
